import React from 'react';
import { observer } from "mobx-react";
import SurveyPage from '../components/SurveyPage';
import SurveyTitleArea from '../components/SurveyTitleArea';
import SurveyContentContainer from '../components/SurveyContentContainer';
import GenericHomePage from '../components/GenericHomePage';
import store from '../components/Stores/SurveyStore';


export const PabsUkHomeTab = observer(() => {
  return (
    <SurveyPage>
      <SurveyTitleArea />
      <SurveyContentContainer homePage={true}>
        <GenericHomePage
          surveyCategoryName='Pension Administration Benchmarking UK'
          contacts={[{
            name: 'James West',
            email: 'james@explorecem.com',
          },
          ]}
          dueDate={`July 31, ${store.currentYear}`}
        />
      </SurveyContentContainer>
    </SurveyPage>
  );
});
